/* Talas smooth (inertial) page scrolling on top of Lenis 1.1.13 (loaded deferred from layout/theme.liquid).
   Off for touch devices (native momentum) and prefers-reduced-motion. Lenis scrolls the real window, so scrollY, position:sticky,
   the parallax layers and the 3D background all follow the same eased value. Idle = no rAF loop. */
(() => {
  if (window.__tsmooth || typeof Lenis === 'undefined') return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || matchMedia('(hover: none), (pointer: coarse)').matches) return;
  const root = document.documentElement;
  const st = document.createElement('style');
  st.textContent = 'html.lenis,html.lenis body{height:auto}.lenis.lenis-smooth{scroll-behavior:auto!important}.lenis.lenis-smooth [data-lenis-prevent]{overscroll-behavior:contain}.lenis.lenis-stopped{overflow:hidden}';
  document.head.appendChild(st);

  const KNOWN = '[data-lenis-prevent],.drawer-wrapper,.lazy-drawer-cart,.drawer-cart,.drawer-search,.modal,.mega-menu,.pswp,.fancybox__container,select,textarea';
  const prevent = (node) => {
    if (!(node instanceof Element)) return false;
    if (node.closest(KNOWN)) return true;
    // any nested scroller that can actually scroll (vertical lists, horizontal swipe rows)
    for (let n = node; n && n !== document.body && n !== root; n = n.parentElement) {
      const cs = getComputedStyle(n);
      if (/(auto|scroll)/.test(cs.overflowY) && n.scrollHeight > n.clientHeight + 1) return true;
      if (/(auto|scroll)/.test(cs.overflowX) && n.scrollWidth > n.clientWidth + 1) return true;
    }
    return false;
  };

  const lenis = new Lenis({ lerp: 0.16, smoothWheel: true, syncTouch: false, wheelMultiplier: 1, prevent });
  window.__tsmooth = { lenis, frames: 0, running: false };
  const S = window.__tsmooth;

  let raf = 0, calm = 0;
  const loop = (t) => {
    raf = 0; S.frames++;
    lenis.raf(t);
    if (lenis.isScrolling) calm = 0; else calm++;
    if (calm < 3) raf = requestAnimationFrame(loop); else S.running = false;
  };
  const wake = () => { calm = 0; if (!raf && !lenis.isStopped) { S.running = true; raf = requestAnimationFrame(loop); } };
  ['wheel', 'keydown', 'scroll', 'resize', 'mousedown'].forEach((e) => addEventListener(e, wake, { passive: true, capture: true }));
  wake();

  // pause while the theme locks the page (drawers, modals, menus)
  const sync = () => { const lock = root.classList.contains('overflow-hidden'); if (lock && !lenis.isStopped) lenis.stop(); else if (!lock && lenis.isStopped) { lenis.start(); wake(); } };
  new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
  sync();

  // programmatic smooth scrolls (theme helpers) go through Lenis
  const nativeScrollTo = window.scrollTo.bind(window);
  window.scrollTo = function (a, b) {
    if (a && typeof a === 'object' && a.behavior === 'smooth' && typeof a.top === 'number' && !lenis.isStopped) { lenis.scrollTo(a.top); wake(); return; }
    return nativeScrollTo.apply(null, arguments);
  };

  const headerH = () => { const h = document.querySelector('header, .header'); if (!h) return 0; const p = getComputedStyle(h).position; return p === 'sticky' || p === 'fixed' ? h.offsetHeight : 0; };
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || lenis.isStopped) return;
    const btt = e.target.closest && e.target.closest('#back-to-top');
    if (btt) { e.preventDefault(); e.stopImmediatePropagation(); lenis.scrollTo(0); wake(); return; }
  }, true);
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || lenis.isStopped) return;
    const a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || a.target === '_blank' || a.hasAttribute('data-lenis-ignore') || /tab|button|switch/.test(a.getAttribute('role') || '')) return;
    const u = new URL(a.href, location.href);
    if (u.origin !== location.origin || u.pathname !== location.pathname || u.search !== location.search) return;
    let el = null;
    if (u.hash.length > 1) { try { el = document.getElementById(decodeURIComponent(u.hash.slice(1))); } catch (_) {} if (!el) return; }
    e.preventDefault();
    const sm = el ? (parseFloat(getComputedStyle(el).scrollMarginTop) || 0) : 0; /* same offset the native jump uses (set by talas-pdp.js) */
    lenis.scrollTo(el || 0, { offset: el ? -(sm || headerH() + 8) : 0 }); wake();
    if (el && history.pushState) history.pushState(null, '', u.hash);
  });
})();
